import styled from 'styled-components';
import { palette, font } from 'styled-theme';

const BaseAppHolder = styled.div`

body{
	border:12px solid red;
}
	/* CircularStd */

	@font-face {
		font-family: 'CircularStd';
		font-style: normal;
		font-display: swap;
		font-weight: 400;
		src: url(https://storage.googleapis.com/assets.twicapp-production.twic.ai/fonts/circular_std/CircularStd-Book.woff2)
				format('woff2'),
			url(https://storage.googleapis.com/assets.twicapp-production.twic.ai/fonts/circular_std/CircularStd-Book.woff)
				format('woff'),
			url(https://storage.googleapis.com/assets.twicapp-production.twic.ai/fonts/circular_std/CircularStd-Book.ttf)
				format('truetype');
	}

	/* CircularStd Bold*/

	@font-face {
		font-family: 'CircularStd';
		font-style: normal;
		font-display: swap;
		font-weight: 700;
		src: url(https://storage.googleapis.com/assets.twicapp-production.twic.ai/fonts/circular_std/CircularStd-Bold.woff2)
				format('woff2'),
			url(https://storage.googleapis.com/assets.twicapp-production.twic.ai/fonts/circular_std/CircularStd-Bold.woff)
				format('woff'),
			url(https://storage.googleapis.com/assets.twicapp-production.twic.ai/fonts/circular_std/CircularStd-Bold.ttf)
				format('truetype');
	}

	font-family: ${font('primary', 0)};

	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	a,
	p,
	li,
	input,
	textarea,
	span,
	div,
	img,
	svg {
		&::selection {
			background: ${palette('primary', 0)};
			color: #fff;
		}
	}

	.ant-row:not(.ant-form-item) {
		${'' /* margin-left: -8px;
    margin-right: -8px; */};
		&:before,
		&:after {
			display: none;
		}
	}

	.ant-row > div {
		padding: 0;
	}

	.isoLeftRightComponent {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
	}

	.isoCenterComponent {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
	}

	.twic-icon {
		margin-right: 5px;
		font-size: 16px;
	}

	p {
		margin-bottom: 5px;
	}

	
`;

export default BaseAppHolder;
